export default __webpack_public_path__ + "static/media/clarify_text_white.c20f1ee4.svg";